import * as PANOLENS from 'panolens';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { animated, useSpring } from 'react-spring';

import Gradient_4 from '../../assets/gradients/gradient_4.png';
import PanoramaEvening from '../../assets/panorama/1_full.webp';
import PanoramaMorning from '../../assets/panorama/2_full.webp';
import PanoramaAfternoon from '../../assets/panorama/3_full.webp';
import PanoramaMorningMob from '../../assets/panorama/compress/morning_compress_mob.jpg';
import {
  handlepanoramaImgsLoading,
  handlePanoramaModel,
  pamoramasSelector,
  panoramaModelSelector,
} from '../../entities/ComponentsSlice';
import { changeActivePanorama } from '../../entities/ProjectSlice';
import { deviceSelector } from '../../entities/UserSlice';
import ButtonClose from '../../features/button-close/ButtonClose';
import PanoramaCompass from '../../features/panorama-compass/PanoramaCompass';
import LoaderCircle from '../../shared/loader-circle/LoaderCircle';
import { preloadImages } from '../../tools/_preload-images';
import style from './PanoramaModal.module.scss';

function PanoramaModal() {
  const [isLoading, setIsLoading] = useState(false);
  const [panoramaY, setPanoramaY] = useState([0, 0, 0]);
  const [loadingError, setLoadingError] = useState(null);
  const device = useSelector(deviceSelector);
  const pamoramasImgesLoading = useSelector(pamoramasSelector);
  const dispatch = useDispatch();
  const panoramaRef = useRef();
  const panoramaRefTwo = useRef();
  const panoramaRefThree = useRef();
  const panPic = device === 'isDesktop' ? PanoramaMorning : PanoramaMorningMob;
  const forBtns = useSelector(state => state.projectinfo.panoramas);

  useEffect(() => {
    if (panoramaRef && panPic && device) {
      dispatch(changeActivePanorama(0));
      setIsLoading(false);

      const panoramas = forBtns.map(item => {
        return new PANOLENS.ImagePanorama(item.imgMob);
      });

      const viewer_1 = new PANOLENS.Viewer({
        container: panoramaRef.current,
        horizontalView: true,
      });

      const viewer_2 = new PANOLENS.Viewer({
        container: panoramaRefTwo.current,
        horizontalView: true,
      });

      const viewer_3 = new PANOLENS.Viewer({
        container: panoramaRefThree.current,
        horizontalView: true,
      });

      viewer_1.OrbitControls.noZoom = true;
      viewer_2.OrbitControls.noZoom = true;
      viewer_3.OrbitControls.noZoom = true;

      viewer_1.add(panoramas[0]);
      viewer_2.add(panoramas[1]);
      viewer_3.add(panoramas[2]);

      // Функция для преобразования радиан в градусы
      function radToDeg(rad) {
        return rad * (180 / Math.PI);
      }

      // Создайте функцию для отслеживания изменений камеры при вращении панорамы
      function trackCameraRotation() {
        // Получите текущие значения камеры
        const cameraRotation_1 = viewer_1.camera.rotation;
        const cameraRotation_2 = viewer_2.camera.rotation;
        const cameraRotation_3 = viewer_3.camera.rotation;

        setPanoramaY([radToDeg(cameraRotation_1.y), radToDeg(cameraRotation_2.y), radToDeg(cameraRotation_3.y)]);
      }

      const panoramaImages = [PanoramaMorning, PanoramaAfternoon, PanoramaEvening];
      const imgs = preloadImages(panoramaImages);
      imgs
        .then(response => {
          dispatch(handlepanoramaImgsLoading(response));
        })
        .catch(error => {
          if (error.message === 'Image load timeout') {
            setLoadingError('Loading took too long. Please try again.');
          } else {
            dispatch(handlepanoramaImgsLoading('error'));
          }
        });

      const intervalId = setInterval(trackCameraRotation, 25);

      const timerId = setInterval(() => {
        return panoramas[0].loaded === true && panoramas[1].loaded === true && panoramas[2].loaded === true;
      }, 1000);

      setTimeout(() => {
        if (timerId && pamoramasImgesLoading === 'load') {
          setIsLoading(true);
          clearInterval(timerId);
        } else {
          timerId();
        }
      }, 1500);

      return function cleanup() {
        clearInterval(intervalId);
      };
    }
  }, [panoramaRef, panPic, device]);

  const openPanoramaModel = useSelector(panoramaModelSelector);

  useEffect(() => {
    if (openPanoramaModel) {
      setToggle(true);
      setTimeout(() => {
        setToggle(false);
      }, 400);
    }
  }, [openPanoramaModel]);

  const [toggle, setToggle] = useState(true);

  const opacityStyle = useSpring({
    config: { duration: 800 },
    opacity: toggle ? 0 : 1,
    delay: 0,
  });

  const changePic = item => {
    dispatch(changeActivePanorama(item.id));
    switch (item.id) {
      case 0:
        panoramaRef.current.style.opacity = 1;
        panoramaRefTwo.current.style.opacity = 0;
        panoramaRefThree.current.style.opacity = 0;
        panoramaRef.current.style.zIndex = 10;
        panoramaRefTwo.current.style.zIndex = 0;
        panoramaRefThree.current.style.zIndex = 0;
        break;
      case 1:
        panoramaRef.current.style.opacity = 0;
        panoramaRefTwo.current.style.opacity = 1;
        panoramaRefThree.current.style.opacity = 0;
        panoramaRef.current.style.zIndex = 0;
        panoramaRefTwo.current.style.zIndex = 10;
        panoramaRefThree.current.style.zIndex = 0;
        break;
      case 2:
        panoramaRef.current.style.opacity = 0;
        panoramaRefTwo.current.style.opacity = 0;
        panoramaRefThree.current.style.opacity = 1;
        panoramaRef.current.style.zIndex = 0;
        panoramaRefTwo.current.style.zIndex = 0;
        panoramaRefThree.current.style.zIndex = 10;
        break;
      default:
        break;
    }
  };

  return (
    <>
      {!navigator.onLine && (
        <div className={style.panoramaModal}>
          <div className={style.panoramaModalPlug}>
            <div
              className={style.panoramaModalClose}
              onClick={() => {
                dispatch(handlePanoramaModel(false));
              }}
              role='button'
              tabIndex='0'
            >
              <ButtonClose id='close_black' className={style.panoramaModalBtnClose} />
            </div>
            <p>Отсутствует соединение с сетью</p>
          </div>
        </div>
      )}

      {loadingError && <div>{loadingError}</div>}
      {openPanoramaModel && pamoramasImgesLoading === 'load' && <LoaderCircle isLoading={isLoading} />}
      {openPanoramaModel && pamoramasImgesLoading === 'error' && navigator.onLine && (
        <div className={style.panoramaModal}>
          <div className={style.panoramaModalPlug}>
            <div
              className={style.panoramaModalClose}
              onClick={() => {
                dispatch(handlePanoramaModel(false));
              }}
              role='button'
              tabIndex='0'
            >
              <ButtonClose id='close_black' className={style.panoramaModalBtnClose} />
            </div>
            <p>При загрузке панорамы произошла ошибка. Попробуйте перезагрузить страницу</p>
          </div>
        </div>
      )}

      {openPanoramaModel && pamoramasImgesLoading === 'load' && (
        <div className={style.panoramaModal}>
          <animated.div style={opacityStyle} className={style.panoramaModalWrapper}>
            <PanoramaCompass className={style.compass} panoramaY={panoramaY} />

            <div
              className={style.panoramaModalClose}
              onClick={() => dispatch(handlePanoramaModel(false))}
              role='button'
              tabIndex='0'
            >
              <ButtonClose id='close_black' className={style.panoramaModalBtnClose} />
            </div>

            <div className={style.panoramaModalContainer} ref={panoramaRef} />

            <div className={style.panoramaModalContainer_two} ref={panoramaRefTwo} />

            <div className={style.panoramaModalContainer_three} ref={panoramaRefThree} />

            {device !== 'isMobile' && <img src={Gradient_4} alt='gradient' className={style.panoramaMinBack} />}

            {device === 'isMobile' && <img src={Gradient_4} alt='gradient' className={style.panoramaMinBack} />}

            <div className={style.panoramaModalBtnsBox}>
              {device &&
                forBtns &&
                forBtns.map(item => (
                  <button
                    key={item.id}
                    className={item.active ? style.panoramaModalBtn + ' ' + style.__active : style.panoramaModalBtn}
                    onClick={() => {
                      changePic(item);
                    }}
                  >
                    {item.title}
                  </button>
                ))}
            </div>
          </animated.div>
        </div>
      )}
    </>
  );
}

export default PanoramaModal;
